<template>
  <div id="test">
123
    <video id="testvideo" class="video-js vjs-default-skin vjs-big-play-centered"></video>
  </div>
</template>

<script>
  export default {
    name: 'test',
    data() {
      return {

      }
    },
    mounted() {
      hwplayerloaded(() => {
          var options = {
              //是否显示控制栏，包括进度条，播放暂停按钮，音量调节等组件
              controls: true, 
              width: 640,
              height: 360,
              //是否开启播放质量数据上报功能
              stat:true,
              // 播放前显示的视频画面，播放开始后自动移除。通常传入一个URL。
              // poster: '',
              preload: 'metadata'
          };
          var player = new HWPlayer('testvideo', 'hwplayer',options, function () {
              //播放器已经准备好了
              this.src("https://35.cdn-vod.huaweicloud.com/asset/ba4f5df688f4ed6f569470d688ec4a22/c5d8003cb1d108035d3a902adb2bc5cc.mp4");
              // "this"指向的是HWPlayer的实例对象player
              this.play();
              // 使用事件监听
              this.on('ended', function () {
              //播放结束了
              });
          });
      });

    }
  }
</script>

<style>

</style>